/**
 * Duty & tax estimate (company side). `?hs=` pre-fills the HS code, e.g. from
 * the product list.
 */
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout/DashboardLayout";
import TradeEstimateTool from "../../components/TradeEstimate/TradeEstimateTool";

const TradeEstimatePage = () => {
  const { t } = useTranslation("trade");
  const [params] = useSearchParams();
  return (
    <DashboardLayout>
      <div style={{ padding: "1.5rem", maxWidth: 1100, margin: "0 auto" }}>
        <header style={{ marginBottom: "1rem" }}>
          <h1 className="dashboard__title">{t("tool.title")}</h1>
          <p className="dashboard__subtitle">{t("tool.subtitle")}</p>
        </header>
        <TradeEstimateTool initialHsCode={params.get("hs") ?? ""} />
      </div>
    </DashboardLayout>
  );
};

export default TradeEstimatePage;
